import React from 'react';

export const TableSmallIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Стулья сверху */}
      <rect x="22" y="8" width="8" height="10" rx="1" fill="#6D4C41" stroke="#3E2723" strokeWidth="1"/>
      <rect x="34" y="8" width="8" height="10" rx="1" fill="#6D4C41" stroke="#3E2723" strokeWidth="1"/>

      {/* Стулья снизу */}
      <rect x="22" y="46" width="8" height="10" rx="1" fill="#6D4C41" stroke="#3E2723" strokeWidth="1"/>
      <rect x="34" y="46" width="8" height="10" rx="1" fill="#6D4C41" stroke="#3E2723" strokeWidth="1"/>

      {/* Стол */}
      <rect x="18" y="20" width="28" height="24" rx="2" fill="#8D6E63" stroke="#4E342E" strokeWidth="1"/>

      {/* Текстура */}
      <line x1="18" y1="28" x2="46" y2="28" stroke="#6D4C41" strokeWidth="1" strokeOpacity="0.6"/>
      <line x1="18" y1="36" x2="46" y2="36" stroke="#6D4C41" strokeWidth="1" strokeOpacity="0.6"/>

      {/* Детали */}
      <circle cx="22" cy="24" r="0.5" fill="#4E342E"/>
      <circle cx="42" cy="40" r="0.5" fill="#4E342E"/>
      <circle cx="42" cy="24" r="0.5" fill="#4E342E"/>
      <circle cx="22" cy="40" r="0.5" fill="#4E342E"/>
    </svg>
  );
};
